import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Storage} from '@ionic/storage';
import Color from 'color';


@Injectable({
    providedIn: 'root'
})
export class ThemeSwitcherService {

    protected static STORAGE_THEME_KEY = 'IonicAngularThemeSwitch_Theme';
    protected static STORAGE_THEME_NAME_KEY = 'IonicAngularThemeSwitch_ThemeName';

    public static primary_color: IonicColors = {
        primary: '#3067cc',
        secondary: '#d1f0ff',
        tertiary: '#2356b3',
        success: '#19a450',
        warning: '#d4a408',
        danger: '#8a1e2d',
        dark: '#3b3e44',
        medium: '#92949c',
        light: '#ffffff',
        'icons-button': '#3067cc',
        'icons-spec': '#ffee00'
    };
    public static package_color_one: IonicColors = {
        primary: '#6b0fba',
        secondary: '#e3d1ff',
        tertiary: '#7a10d5',
        success: '#137f3c',
        warning: '#a78006',
        danger: '#7f1b2a',
        dark: '#3b3e44',
        medium: '#92949c',
        light: '#ffffff',
        'icons-button': '#6b0fba',
        'icons-spec': '#ffee00'
    };
    public static package_color_two: IonicColors = {
        primary: '#05720b',
        secondary: '#e3d1ff',
        tertiary: '#1b9e22',
        success: '#10ce59',
        warning: '#a78006',
        danger: '#7f1b2a',
        dark: '#3b3e44',
        medium: '#92949c',
        light: '#ffffff',
        'icons-button': '#05720b',
        'icons-spec': '#ffee00'
    };
    public static package_color_three: IonicColors = {
        primary: '#ff6f00',
        secondary: '#ffcb3d',
        tertiary: '#f7f4a6',
        success: '#2dd36f',
        warning: '#ffc409',
        danger: '#eb445a',
        dark: '#222428',
        medium: '#92949c',
        light: '#f4f5f8',
        'icons-button': '#404040',
        'icons-spec': '#2f2f2f'
    };
    public static package_color_four: IonicColors = {
        primary: '#ff0000',
        secondary: '#ff6666',
        tertiary: '#ffcccc',
        success: '#2dd36f',
        warning: '#ffc409',
        danger: '#eb445a',
        dark: '#222428',
        medium: '#92949c',
        light: '#f4f5f8',
        'icons-button': '#404040',
        'icons-spec': '#ffcdcd'
    };
    public static package_color_five: IonicColors = {
        primary: '#ff00bb',
        secondary: '#ffaddd',
        tertiary: '#ffebfa',
        success: '#2dd36f',
        warning: '#ffc409',
        danger: '#eb445a',
        dark: '#222428',
        medium: '#92949c',
        light: '#f4f5f8',
        'icons-button': '#650063',
        'icons-spec': '#f4e0ff'
    };
    public static package_color_six: IonicColors = {
        primary: '#00d9ff',
        secondary: '#80ecff',
        tertiary: '#dbfaff',
        success: '#2dd36f',
        warning: '#ffc409',
        danger: '#eb445a',
        dark: '#222428',
        medium: '#92949c',
        light: '#f4f5f8',
        'icons-button': '#404040',
        'icons-spec': '#d6faff'
    };
    public static package_color_seven: IonicColors = {
        primary: '#e2e600',
        secondary: '#dbdd7e',
        tertiary: '#eaebcb',
        success: '#2dd36f',
        warning: '#ffc409',
        danger: '#eb445a',
        dark: '#636363',
        medium: '#92949c',
        light: '#ffffff',
        'icons-button': '#404040',
        'icons-spec': '#383838'
    };
    public static package_color_nine: IonicColors = {
        primary: '#2b1547',
        secondary: '#5e2ca0',
        tertiary: '#9444fd',
        success: '#21a656',
        warning: '#dfab01',
        danger: '#c03547',
        dark: '#636363',
        medium: '#92949c',
        light: '#ffffff',
        'icons-button': '#2b1547',
        'icons-spec': '#f5f5f5'
    };
    public static package_color_ten: IonicColors = {
        primary: '#355101',
        secondary: '#527e02',
        tertiary: '#d8ff8f',
        success: '#21a656',
        warning: '#dfab01',
        danger: '#c03547',
        dark: '#636363',
        medium: '#92949c',
        light: '#ffffff',
        'icons-button': '#355101',
        'icons-spec': '#f5f5f5'
    };

    public static package_dark_template: IonicColors = {
        primary: '#000000',
        secondary: '#b0b0b0',
        tertiary: '#ebebeb',
        success: '#2dd36f',
        warning: '#ffc409',
        danger: '#eb445a',
        dark: '#222428',
        medium: '#92949c',
        light: '#e6e6e6',
        'icons-spec': '#c6c6c6',
        'icons-button': '#848484',
        'ion-background-color': '#232323',
        'ion-text-color': '#fff',
        'ion-item-background': '#2d2d2d',
        'ion-item-color': '#fff',
        'ion-toolbar-background': '#181818',
        'ion-toolbar-border-color': '#343434',
        'ion-toolbar-color': '#fff',
        'ion-color-step-50': '#0d0d0d',
        'ion-color-step-100': '#1a1a1a',
        'ion-color-step-150': '#262626',
        'ion-color-step-200': '#333333',
        'ion-color-step-250': '#404040',
        'ion-color-step-300': '#4d4d4d',
        'ion-color-step-350': '#595959',
        'ion-color-step-400': '#666666',
        'ion-color-step-450': '#737373',
        'ion-color-step-500': '#808080',
        'ion-color-step-550': '#8c8c8c',
        'ion-color-step-600': '#999999',
        'ion-color-step-650': '#a6a6a6',
        'ion-color-step-700': '#b3b3b3',
        'ion-color-step-750': '#bfbfbf',
        'ion-color-step-800': '#cccccc',
        'ion-color-step-850': '#d9d9d9',
        'ion-color-step-900': '#e6e6e6',
        'ion-color-step-950': '#f2f2f2'
    };

    constructor(
        @Inject(DOCUMENT) private doc: Document,
        private storage: Storage
    ) {
        this.storage.get(ThemeSwitcherService.STORAGE_THEME_KEY).then(cssText => {
            if (cssText) {
                this.setGlobalCSS(cssText);
            }
        });
    }

    getBaseColorTheme(theme: string): IonicColors {
        let ionicColors: IonicColors;
        switch (theme) {
            case 'primary_color':
                ionicColors = ThemeSwitcherService.primary_color;
                break;
            case 'package_color_one':
                ionicColors = ThemeSwitcherService.package_color_one;
                break;
            case 'package_color_two':
                ionicColors = ThemeSwitcherService.package_color_two;
                break;
            case 'package_color_three':
                ionicColors = ThemeSwitcherService.package_color_three;
                break;
            case 'package_color_four':
                ionicColors = ThemeSwitcherService.package_color_four;
                break;
            case 'package_color_five':
                ionicColors = ThemeSwitcherService.package_color_five;
                break;
            case 'package_color_six':
                ionicColors = ThemeSwitcherService.package_color_six;
                break;
            case 'package_color_seven':
                ionicColors = ThemeSwitcherService.package_color_seven;
                break;
            case 'package_color_nine':
                ionicColors = ThemeSwitcherService.package_color_nine;
                break;
            case 'package_color_ten':
                ionicColors = ThemeSwitcherService.package_color_ten;
                break;
            case 'package_dark_template' :
                ionicColors = ThemeSwitcherService.package_dark_template;
                break;

        }
        return ionicColors;
    }

    // Override all global variables with a new theme
    setTheme(theme: IonicColors = {}, name: string = ''): void {
        const cssText = this.CSSTextGenerator(theme);
        // console.log(cssText)
        this.setGlobalCSS(cssText);
        this.storage.set(ThemeSwitcherService.STORAGE_THEME_KEY, cssText).then();
        this.storage.set(ThemeSwitcherService.STORAGE_THEME_NAME_KEY, name).then();
    }

    // Define a single CSS variable
    setVariable(name: string, value: string): void {
        this.doc.documentElement.style.setProperty(name, value);
    }

    private setGlobalCSS(css: string): void {
        this.doc.documentElement.style.cssText = css;
    }

    async getStoredTheme(): Promise<string> {
        return this.storage.get(ThemeSwitcherService.STORAGE_THEME_KEY);
    }

    async getStoredThemeName(): Promise<string> {
        return this.storage.get(ThemeSwitcherService.STORAGE_THEME_NAME_KEY);
    }

    private CSSTextGenerator(colors: IonicColors = {}) {
        const shadeRatio = 0.12;
        const tintRatio = 0.2;
        const colorNames = Object.keys(colors);

        if (colorNames.length === 0) {
            return '';
        }

        let result = ``;

        colorNames.forEach(name => {
            if (colors.hasOwnProperty(name)) {
                const colorHex = colors[name];
                const colorColor = Color(colorHex);

                if (name.startsWith('ion-')) {
                    result += `
    --${name}: ${colorHex};
    --${name}-rgb: ${this.colorToRgb(colorColor)};
      `;
                } else {
                    const contrastColorHex = this.contrast(colorColor);
                    result += `
    --ion-color-${name}: ${colorHex};
    --ion-color-${name}-rgb: ${this.colorToRgb(colorColor)};
    --ion-color-${name}-contrast: ${contrastColorHex};
    --ion-color-${name}-contrast-rgb: ${this.colorToRgb(contrastColorHex)};
    --ion-color-${name}-shade:  ${colorColor.darken(shadeRatio)};
    --ion-color-${name}-tint:  ${colorColor.lighten(tintRatio)};
      `;

                }
            }
        });

        if (colors.hasOwnProperty('ion-background-color') && !colors.hasOwnProperty('ion-text-color')) {
            colors['ion-text-color'] = '#fff';
        } else if (!colors.hasOwnProperty('ion-background-color') && colors.hasOwnProperty('ion-text-color')) {
            colors['ion-background-color'] = '#000';
        }
        if (colors.hasOwnProperty('ion-background-color') && colors.hasOwnProperty('ion-text-color')) {
            const colorBackground = Color(colors['ion-background-color']);
            const colorText = Color(colors['ion-text-color']);

            let i = 50;
            do {
                const colorStep = colorText.mix(colorBackground, 1 - i / 1000);
                result += `
    --ion-color-step-${i}: ${colorStep};
    --ion-color-step-${i}-rgb: ${this.colorToRgb(colorStep)};
    `;
                i += 50;
            } while (i < 1000);
        }

        return result;
    }

    private contrast(color, ratio = 0.8) {
        return color.isDark() ? color.lighten(ratio) : color.darken(ratio);
    }

    private colorToRgb(color) {
        return color.rgb().round().array().join(', ');
    }

    async getPrimaryColorTheme(): Promise<string> {
        const theme = await this.storage.get(ThemeSwitcherService.STORAGE_THEME_NAME_KEY);
        return Promise.resolve(this.getBaseColorTheme(theme).primary);
    }
}

export interface IonicColors {
    primary?: string;
    secondary?: string;
    tertiary?: string;
    success?: string;
    warning?: string;
    danger?: string;
    dark?: string;
    medium?: string;
    light?: string;
    'ion-background-color'?: string;
    'ion-text-color'?: string;
    'ion-backdrop-color'?: string;
    'ion-overlay-background-color'?: string;
    'ion-border-color'?: string;
    'ion-box-shadow-color'?: string;
    'ion-tab-bar-background'?: string;
    'ion-tab-bar-background-focused'?: string;
    'ion-tab-bar-border-color'?: string;
    'ion-tab-bar-color'?: string;
    'ion-tab-bar-color-activated'?: string;
    'ion-toolbar-background'?: string;
    'ion-toolbar-border-color'?: string;
    'ion-toolbar-color'?: string;
    'ion-toolbar-color-activated'?: string;
    'ion-toolbar-color-unchecked'?: string;
    'ion-toolbar-color-checked'?: string;
    'ion-item-background'?: string;
    'ion-item-background-activated'?: string;
    'ion-item-border-color'?: string;
    'ion-item-color'?: string;
    'ion-placeholder-color'?: string;
    'icons-spec'?: string;
    'icons-button'?:string;
    [key: string]: string;

    themeName?: string;
}
